import { render, staticRenderFns } from "./WalletTransactionModal.vue?vue&type=template&id=1beef87a&scoped=true&"
import script from "./WalletTransactionModal.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletTransactionModal.vue?vue&type=style&index=0&id=1beef87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beef87a",
  null
  
)

export default component.exports